module.exports = __webpack_public_path__ + "static/media/img-location-taoyuan-zh.5c52012a.svg";